<script lang="ts">
import { Component } from 'vue-property-decorator'
import BaseButtonBulk from './BaseButtonBulk.vue'

@Component({
  name: 'CancelSalesBulkButton',
})
export default class CancelSalesBulkButton extends BaseButtonBulk {
  protected color = 'is-danger'

  get disabled() {
    // Disable if any item in the list is missing a cancellation reason
    return !this.actionList.every(
      (storedAction) => !!storedAction.item.actionData.cancellationReason
    )
  }

  protected onClick() {
    if (this.disabled) return

    // Through submitActionForItems for the concurrency cap and the batched
    // refresh; this used to fire every cancel in the same tick (EH-1877)
    this.submitActions(
      this.actionList.filter((storedAction) => !!storedAction.item.actionData.cancellationReason)
    )
  }
}
</script>
